/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Request_SentInputs */



/**
* | output |
* | --- |
* | "Your request to join the portal has been sent. The agency will review it and reply by email." |
*
* @param {Portal_X13_Request_SentInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const portal_x13_request_sent = /** @type {((inputs?: Portal_X13_Request_SentInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Request_SentInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Your request to join the portal has been sent. The agency will review it and reply by email.")
});